module.exports = __webpack_public_path__ + "school/img/jidiminglu.db09eb46.jpg";